var cov_13iym54ye4 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Icon/styles/index.ts",
      hash = "7f286f957c1624f5c3c55622533bf7f83de0a441",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Icon/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 25
        },
        end: {
          line: 5,
          column: 53
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var iconLess = {};
import genaration from '../../utils/classname';
export var iconClass = (cov_13iym54ye4.s[0]++, genaration(iconLess, 'icon'));